import React, { useEffect, useState, useCallback } from "react";
import { useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import LeaveTable from "./LeaveTable";
import { Button } from "@material-ui/core";
import Spacer from "../../../components/Spacer";
import MainContainer from "../../../components/MainContainer";
import { headerDataRH } from "../../../data/modules/hr-header";
import { userDetailContext } from "../../../App";
import { hasPrivilege } from "../../../utils/privilege";
import Planning from "../../tools/planning";
import RequestValidationService from "../../../services/RequestValidationService";
import LoadingSimpleBackdrop from "../../tools/LoadingSimpleBackdrop";
import Message from "../../tools/Message";
import { useNavigate, useLocation } from 'react-router-dom';
import BalanceConfigurationService from "../../../services/BalanceConfigurationService";
import UserService from "../../../services/UserService";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    elevation: 0,
  },
}));

export default function LeaveList(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const contextData = useContext(userDetailContext);
  const [status, setStatus] = useState(1);
  const [activeButton, setActiveButton] = useState(true);
  const [message, setMessage] = useState({
    open: false,
    color: 'green',
    messageInfo: '',
  });
  const { open, color, messageInfo } = message;
  const [isLoading, setIsLoading] = useState(false);
  const [confirmationDialog, setConfirmationDialog] = React.useState({
    openDialog: false,
    messageDialog: 'Voulez-vous vraiment envoyer votre planification de congé de la date du',
  });
  const { openDialog, messageDialog } = confirmationDialog;
  const [openLoadingSimpleBackdrop, setOpenLoadingSimpleBackdrop] = React.useState(false);

  const [isRealBalanceAlreadyConfigurate, setIsRealBalanceAlreadyConfigurate] = useState(false);
  const [errorMessageForRealBalanceEmpty, setErrorMessageForRealBalanceEmpty] = useState("");
  const [userConnectedName, setUserConnectedName] = useState('');
  const [userConnectedActualBalance, setUserConnectedActualBalance] = useState('');

  const classes = useStyles();

  const loadUserData = useCallback(() => {
    const userConnectedId = localStorage.getItem("USER");
    if (userConnectedId) {
      UserService.getUserSummaryByUserId(userConnectedId).then((res) => {
        if (res && res.status) {
          const name = (!res.data.first_name && res.data.first_name !== null && res.data.first_name !== "") 
            ? res.data.first_name 
            : res.data.last_name;
          setUserConnectedName(name);
        }
      });
    }
  }, []);

  const loadBalanceData = useCallback(() => {
    BalanceConfigurationService.isInitialBalanceConfigurated().then((res) => {
      if (res && res.status) {
        setIsRealBalanceAlreadyConfigurate(true);
        localStorage.setItem("isInitialBalanceConfigurated", true);
      } else {
        setIsRealBalanceAlreadyConfigurate(false);
        setErrorMessageForRealBalanceEmpty(res.message);
        localStorage.setItem("isInitialBalanceConfigurated", false);
      }
    });

    BalanceConfigurationService.getUserConnectedBalanceDetail().then((result) => {
      if (result && result.status) {
        localStorage.setItem("realBefore", result.data.actualBalance);
        setUserConnectedActualBalance(result.data.actualBalance);
      }
    });
  }, []);

  useEffect(() => {
    const checkValidationStatus = async () => {
      try {
        const res = await RequestValidationService.verification();
        if (res && res.status) {
          setActiveButton(false);
        }
      } catch (error) {
        console.error("Error checking validation status:", error);
      }
    };

    checkValidationStatus();
    loadUserData();
    loadBalanceData();
  }, [loadUserData, loadBalanceData]);

  const handleClick = useCallback(() => {
    navigate("/me/leaves/add");
  }, [navigate]);

  const handelClickConfirmation = useCallback(() => {
    setConfirmationDialog({ ...confirmationDialog, openDialog: true });
  }, [confirmationDialog]);

  const closeDialog = useCallback(() => {
    setConfirmationDialog({ ...confirmationDialog, openDialog: false });
  }, [confirmationDialog]);

  const cancelDialog = useCallback(() => {
    setConfirmationDialog({ ...confirmationDialog, openDialog: false });
  }, [confirmationDialog]);

  const LoadTable = useCallback(() => {
    navigate("/me/leaves");
  }, [navigate]);

  const confirmDialog = useCallback(() => {
    setIsLoading(true);
    RequestValidationService.saveRequestValidation().then((result) => {
      var responseErrorMessage = result.message;
      if (result.status) {
        setIsLoading(false);
        setMessage({ ...message, open: true, color: 'green', messageInfo: "votre planning a été envoyé avec succès" });
        cancelDialog();
        LoadTable();
      } else {
        setIsLoading(false);
        cancelDialog();
        setMessage({ ...message, open: true, color: 'red', messageInfo: responseErrorMessage });
      }
    });
  }, [message, cancelDialog, LoadTable]);

  const handleCloseMessage = useCallback(() => {
    setMessage({ ...message, open: false });
  }, [message]);

  return (
    <MainContainer {...headerDataRH}>
      <Planning 
        openDialog={openDialog} 
        messageDialog={messageDialog} 
        closeDialog={closeDialog} 
        confirmDialog={confirmDialog} 
        cancelDialog={cancelDialog} 
        isLoading={isLoading}
      />
      <Message open={open} color={color} messageInfo={messageInfo} handleClose={handleCloseMessage} />
      <LoadingSimpleBackdrop openLoadingSimpleBackdrop={openLoadingSimpleBackdrop} />
      
      <Grid container item xs={12}>
        <Grid item xs={6}>
          {hasPrivilege(contextData.privileges, 'RH_Button_Create_Planning') &&
            <Button
              variant="contained"
              color="secondary"
              onClick={handleClick}
              style={{ fontWeight: 600 }}
            >
              CREER
            </Button>
          }
        </Grid>
        <Grid item xs={3}>
        </Grid>
        <Grid item xs={3}>
          {hasPrivilege(contextData.privileges, 'RH_Button_Validate_Planning') && activeButton &&
            <Button
              variant="contained"
              color="secondary"
              onClick={handelClickConfirmation}
              style={{ fontWeight: 600 }}
            >
              ENVOYER PLANIFICATION
            </Button>
          }
        </Grid>
      </Grid>
      
      <Spacer y={2} />
      
      <Grid container spacing={3} item>
        <Grid item xs={12}>
          <Paper className={classes.paper} variant="outlined">
            <LeaveTable 
              userConnectedName={userConnectedName} 
              userConnectedActualBalance={userConnectedActualBalance}
              status={status}
              setStatus={setStatus}
            />
          </Paper>
        </Grid>
      </Grid>
    </MainContainer>
  );
}